import { render, staticRenderFns } from "./OwnerSingleCarView.vue?vue&type=template&id=23fc156a&"
import script from "./OwnerSingleCarView.vue?vue&type=script&lang=js&"
export * from "./OwnerSingleCarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports